import { Image } from '@faxi/web-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SignIfCard from '../SignIfCard';
import { StyledSplashSection } from './SplashSection.styled';

const SplashSection: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledSplashSection className="cedolauto-splash">
      <div className="cedolauto-splash__heading">
        <h1 className="cedolauto-splash__heading__title">CEDOLAUTO</h1>

        <div className="cedolauto-splash__heading__description">
          {t('ced-hero-subtitle')}
        </div>
      </div>

      <div className="cedolauto-splash__content">
        <SignIfCard />

        <div className="cedolauto-splash__content__powered-by">
          <p>{t('header-support-text')}</p>

          <Image
            src="svg/tfs_logo.svg"
            alt=""
            className="cedolauto-splash__content__powered-by__logo"
          />
        </div>
      </div>
    </StyledSplashSection>
  );
};

export default SplashSection;
